import React from 'react';
import useReveal from '../../AIEmployees/useReveal';
import WallFrame from '../../AIEmployees/sections/WallFrame';
import { SUBAGENTS_CHAT_FRAME } from './subagentsFrame';

/**
 * SASubagents: Subagents on /super-agents (Nitish, Oct 12 2026: right after "One prompt. Any output.").
 * A regular chat splits big work across helpers (CellCog chats, the owner's own Claude Code / Codex / Cursor),
 * rests while they run, and reviews each result. Same frame as the /ai-employees wall's 03 · SUBAGENTS pane,
 * with "Your chat" in place of Riley (WallFrame html prop). Facts: CellCog Subagents Guide.
 */
const SASubagents = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-sag aie-section" id="subagents">
      <div className="aie-section-head">
        <span className="aie-eyebrow">Subagents</span>
        <h2 className="aie-section-title aie-display">One chat, many hands.</h2>
        <p className="aie-section-sub">
          Big work splits across helpers that run at once: other CellCog chats for research and media, your own
          Claude Code, Codex or Cursor for the code. The chat steps away while they work, then reads every result
          before it answers you. Claude Code, Codex and Cursor run on the subscription you already pay for, not
          CellCog credits.
        </p>
      </div>
      <div className={`sa-sag__reveal aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        <WallFrame cls="wm-sag" html={SUBAGENTS_CHAT_FRAME} />
      </div>
    </section>
  );
};

export default SASubagents;
